import React, { useContext } from "react";
import GlobalContext from "../context/GlobalContext";

export default function CreateEventButton() {
  const { setShowEventModal, isReadonly } = useContext(GlobalContext);

  return (
    <button
      type="button"
      onClick={() => !isReadonly && setShowEventModal(true)}
      className={`btn-ghost w-full gap-2 py-2.5${isReadonly ? " hidden" : ""}`}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
        <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11zM7 11h5v5H7z" />
      </svg>
      Nieuwe afspraak
    </button>
  );
}
